import React from "react";
import { Box, Typography, styled } from "@mui/material";
import { useSelector } from "react-redux";
import Logo from "assets/images/newLogo.png";
import { menuSections } from "./sidebar.data";
import SidebarNavItem from "./sidebar-nav-item";
import SidebarUserMenu from "./sidebar-user-menu";

const SIDEBAR_WIDTH = 280;

const SidebarRoot = styled(Box)(({ theme }) => ({
  width: SIDEBAR_WIDTH,
  minWidth: SIDEBAR_WIDTH,
  height: "100vh",
  backgroundColor: theme.palette.background.paper,
  borderRight: `1px solid ${theme.palette.divider}`,
  display: "flex",
  flexDirection: "column",
  position: "sticky",
  top: 0,
  left: 0,
  zIndex: 40,
  overflowY: "auto",
}));

const SidebarHeader = styled(Box)(({ theme }) => ({
  height: 64,
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 2),
  flexShrink: 0,
}));

const SectionLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.7rem",
  fontWeight: 600,
  textTransform: "uppercase",
  color: theme.palette.text.secondary,
  letterSpacing: "0.08em",
  padding: theme.spacing(0, 1.5),
  marginBottom: theme.spacing(0.5),
}));

const useCurrentRoles = () => {
  const reduxRoles = useSelector((s) => s.auth?.roles ?? []);
  if (reduxRoles && reduxRoles.length > 0) return reduxRoles;
  try {
    const saved = JSON.parse(localStorage.getItem("auth:roles") || "[]");
    return Array.isArray(saved) ? saved : [];
  } catch {
    return [];
  }
};

const AppSidebar = () => {
  const roles = useCurrentRoles();

  const isVisible = (item) =>
    !item.requiredRoles || item.requiredRoles.some((r) => roles.includes(r));

  const visibleSections = menuSections
    .map((section) => ({
      ...section,
      items: section.items
        .filter(isVisible)
        .map((item) => ({
          ...item,
          children: item.children?.filter(isVisible),
        })),
    }))
    .filter((section) => section.items.length > 0);

  return (
    <SidebarRoot>
      <SidebarHeader>
        <img src={Logo} alt="logo" style={{ width: 120 }} />
      </SidebarHeader>

      <Box sx={{ flex: 1, py: 1, px: 1, display: "flex", flexDirection: "column", gap: 2, overflowY: "auto" }}>
        {visibleSections.map((section) => (
          <Box key={section.title}>
            <SectionLabel>{section.title}</SectionLabel>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              {section.items.map((item) => (
                <SidebarNavItem key={item.name} item={item} />
              ))}
            </Box>
          </Box>
        ))}
      </Box>

      <SidebarUserMenu />
    </SidebarRoot>
  );
};

export default AppSidebar;